import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=777c85df&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=777c85df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777c85df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777c85df')) {
      api.createRecord('777c85df', component.options)
    } else {
      api.reload('777c85df', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=777c85df&scoped=true&", function () {
      api.rerender('777c85df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25UFeUU46JgMz/JS/teamMember.vue"
export default component.exports